import { StylesDerivedNativeActions } from '@wix/editor-platform-host-integration-apis';
import createDefaultActionDefinition from '../common/actionDefinition/default';
import { createTextValidator } from './validator';

export { parseFontValue } from './parser';

const textAction = {
  ...createDefaultActionDefinition(StylesDerivedNativeActions.textStyles),
  validator: createTextValidator(),
};

export default textAction;
